import { useEffect } from 'react';
import { useRouter } from 'next/router';

const adjustPositions = () => {
  const dotsElements = document.querySelectorAll('.slick-dots');
  const prevElements = document.querySelectorAll('.slick-prev');
  const nextElements = document.querySelectorAll('.slick-next');

  dotsElements.forEach((dotElement, index) => {
    const dotWidth = dotElement.offsetWidth;
    const rightPosition = `calc(50% - calc(${dotWidth}px + 100px) / 1.8)`;
    const leftPosition = `calc(50% - calc(${dotWidth}px + 100px) / 1.8)`;

    const prevElement = prevElements[index];
    if (prevElement) {
      prevElement.style.left = leftPosition;
    }

    const nextElement = nextElements[index];
    if (nextElement) {
      nextElement.style.right = rightPosition;
    }
  });
};

const useSlickPositioning = () => {
  const router = useRouter();

  useEffect(() => {
    adjustPositions();

    window.addEventListener('resize', adjustPositions);
    router.events.on('routeChangeComplete', adjustPositions);

    return () => {
      window.removeEventListener('resize', adjustPositions);
      router.events.off('routeChangeComplete', adjustPositions);
    };
  }, []);
};

export default useSlickPositioning;
